// This will be our public facing page for the DanD tech notes app
import { Link } from "react-router-dom";

import React from 'react'

const Public = () => {
  const content = (
    <section>
        <header>
            <h1>Welcome to <span className="nowrap">afrahDev company!</span></h1>
        </header>
        <main className="public__main">
            <p>Located worldwide, with all the features you need for developing your dream application</p>
            <address className="public__addr">
                afrahDev company<br></br>
                3333 afrahDev<br/>
                Istanbul/Turkey<br/>
                <a href="tel:+123456789">(000) 123-246-789</a>
            </address>
            <br/>
            <p>Owner: Afrah</p>
        </main>
        <footer>
            <Link to="/login">Employee Login</Link>
        </footer>
    </section>
  )
  return content
}

export default Public